import { msg } from "@lingui/core/macro";
import type { JSX } from "solid-js";
import { useI18n } from "@/providers/i18n-provider";

/**
 * Keyboard-only skip link. Hidden until focused (first Tab on the page), then
 * jumps focus to the routed `#main-content` region — bypassing the header,
 * sidebar and tab bar. Theme-safe and visible-on-focus only.
 */
function handleActivate(e: Event) {
  e.preventDefault();
  const target = document.querySelector<HTMLElement>("#main-content");
  if (target) {
    target.setAttribute("tabindex", "-1");
    target.focus();
  }
}

export function SkipToContent(): JSX.Element {
  const { t } = useI18n();

  return (
    <a
      href="#main-content"
      onClick={handleActivate}
      class="sr-only focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:z-[400] focus:rounded-lg focus:bg-primary focus:px-4 focus:py-2 focus:text-sm focus:font-semibold focus:text-primary-foreground focus:shadow-lg focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2"
    >
      {t(msg`Skip to content`)}
    </a>
  );
}
